import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3b923ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewResourceStatistics" }
const _hoisted_2 = { class: "statistical" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from "@/service/main/system";
import {useStore} from "@/store";
import dayjs from "dayjs";
import {ref} from "vue";
import {queryStatisticalNewResource} from "@/service/main/live/statitiscal";
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewResourceStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getGroupList = async () => {
  let groupData = await getListData('/main/enterpriseWechat/dingDept/getGroupList', {})
  const groupId = searchFormConfig.formItems.find((item) => item.field === 'groupId')
  groupId!.options = groupData.map((item: any) => {
    return {title: item.deptName, value: item.deptId}
  })
}
getGroupList()

const queryParam = {
  addTimeSlot: [
    dayjs().subtract(7, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  delTimeSlot: [
    dayjs().subtract(7, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo:1,
  pageSize:10
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  getStatistics(queryParam)
  return queryParam
}
const statistical = ref({addNum: 0, delNum: 0})

const getStatistics = async (item: any) => {
  statistical.value = await queryStatisticalNewResource(item)
}

getStatistics(queryParam)

const searchCb = async (item: any) => {
  await getStatistics(item)
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb, searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("客户添加数: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.addNum), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("删除客户数: "),
        _createElementVNode("em", null, _toDisplayString(statistical.value.delNum), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "newResourceStatistics",
      downFilename: "新资源删除统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})